import React from 'react';
import { VStack, HStack, Text, Image } from '@chakra-ui/react';

interface InstructionStepItemProps {
    number: number;
    text: string;
    imageSrc?: string;
}

const InstructionStepItem: React.FC<InstructionStepItemProps> = ({ number, text, imageSrc }) => {
    return (
        <VStack align="stretch" gap={2}>
            <HStack align="flex-start" gap={2}>
                <Text color="yellow.600" fontWeight="bold">
                    {number}.
                </Text>
                <Text color="black" fontSize="md">
                    {text}
                </Text>
            </HStack>
            {imageSrc && (
                <Image
                    src={imageSrc}
                    alt=""
                    maxW="70%"
                    borderRadius="md"
                    objectFit="contain"
                    alignSelf="flex-start"
                    pl={6}
                />
            )}
        </VStack>
    );
};

export default InstructionStepItem;
